"use client"

import { useEffect } from "react"
import { captureStoreAttribution } from "@/lib/tracking/attribution"

/**
 * Guarda en una cookie propia del host (dominio propio o useredy.com) de dónde
 * llegó el cliente a la página del negocio: utm_*, fbclid/gclid o el sitio que
 * lo mandó. El checkout la lee y la manda con el pedido. Reglas en
 * lib/tracking/attribution.ts. No pinta nada; sin cookies, simplemente no mide.
 */
export function AttributionCapture() {
  useEffect(() => {
    try {
      captureStoreAttribution({ doc: document, loc: window.location, now: new Date() })
    } catch {
      // Medición: nunca rompe la tienda.
    }
  }, [])
  return null
}
